import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vueCountryRegionSelect from "vue3-country-region-select";
import store from "./store";
import { VueReCaptcha } from "vue-recaptcha-v3";
createApp(App)
  .use(store)
  .use(router)
  .use(vueCountryRegionSelect)
  .use(VueReCaptcha, { siteKey: "6Ld8RAobAAAAAN5xIFdLSdRaAHRRQ2YNZKD089Sb" })

  .mount("#app");
let hubspotFrontEnd = document.createElement("script");
hubspotFrontEnd.setAttribute(
  "src",
  process.env.NODE_ENV === "production"
    ? "//js.hs-scripts.com/5108583.js"
    : "//js.hs-scripts.com/19900094.js"
);
document.body.appendChild(hubspotFrontEnd);
